import navbar from "./CN/navbar";
import header from "./CN/header";

export default {
  ...navbar,
  ...header
};
